import { Link } from 'react-router-dom';
import { productPath, inquiryPath } from '../../constants/navigation';
import { AnimatedCard } from './AnimatedCard';
import { CTAButton } from './CTAButton';

export function ProductCard({ product, compact = false }) {
  return (
    <AnimatedCard
      as="article"
      className="bg-white/5 backdrop-blur-sm rounded-3xl border border-purple-500/20 overflow-hidden"
    >
      <Link to={productPath(product.slug)} className="block">
        <div className="aspect-square bg-darker/50 flex items-center justify-center p-8 group">
          <img
            src={product.image}
            alt={product.imageAlt}
            className="max-h-full max-w-full object-contain drop-shadow-2xl group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      </Link>
      <div className="p-8">
        <span
          className={`inline-block text-xs font-semibold uppercase tracking-wider ${product.badgeClass} px-3 py-1 rounded-full mb-3`}
        >
          {product.badge}
        </span>
        <h3 className="text-2xl font-bold mb-3">{product.title}</h3>
        <p className="text-purple-400 text-xs mb-3">{product.priceNote}</p>
        <p className="text-purple-200 mb-6 leading-relaxed">
          {compact ? product.shortDesc : product.description}
        </p>
        {!compact && (
          <>
            <h4 className="text-sm font-semibold text-secondary mb-3">产品亮点</h4>
            <ul className="space-y-2 text-purple-200 text-sm mb-6">
              {product.highlights.map((text) => (
                <li key={text} className="flex items-start">
                  <i className="fa fa-leaf text-green-400 mt-0.5 mr-2" />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
            <dl className="grid grid-cols-2 gap-3 text-sm border-t border-purple-500/20 pt-6 mb-6">
              {product.specs.slice(0, 4).map((spec) => (
                <div key={spec.label}>
                  <dt className="text-purple-400 mb-1">{spec.label}</dt>
                  <dd className="text-light">{spec.value}</dd>
                </div>
              ))}
            </dl>
          </>
        )}
        <div className="flex flex-wrap gap-3">
          <Link
            to={productPath(product.slug)}
            className="inline-flex items-center text-secondary font-semibold hover:underline text-sm"
          >
            查看详情 <i className="fa fa-arrow-right ml-2 text-xs" />
          </Link>
          <CTAButton to={inquiryPath(product.slug)} variant="outline" size="sm" icon="fa-shopping-cart">
            购买咨询
          </CTAButton>
        </div>
      </div>
    </AnimatedCard>
  );
}
